import React from 'react';
import ContactHero from './ContactHero';
import ContactInfo from './ContactInfo';
import { useSEO } from '../../hooks/useSEO';

const MAP_EMBED = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3799.9560906050836!2d31.1558!3d-17.8329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1931a62a2fb0a0e7%3A0x8b7b9d15f3e6cb0a!2sMabvuku%2C%20Harare%2C%20Zimbabwe!5e0!3m2!1sen!2szw!4v1700000000000';

const Contact: React.FC = () => {
  useSEO({
    title: 'Contact Us',
    description: 'Get a free quote today. Contact our Harare office for medical supplies and hospital equipment enquiries.',
    canonical: '/contact',
    schema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "How do I request a quote for medical supplies?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can request a quote by filling out our contact form, calling our Harare office at +263 77 413 4805, or using the WhatsApp inquiry button on any product page."
          }
        },
        {
          "@type": "Question",
          "name": "Do you deliver medical equipment across Zimbabwe?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Manlab Medicals delivers medical and laboratory equipment across Zimbabwe and the wider sub-Saharan Africa region."
          }
        },
        {
          "@type": "Question",
          "name": "Are your products CE and FDA certified?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we prioritize quality and safety by supplying products that are CE certified and FDA approved."
          }
        }
      ]
    }
  });

  return (
    <main className="pt-20">
      <ContactHero />
      <section className="w-full min-h-[500px] flex flex-col">
          <iframe
            title="Harare Office Map"
            src={MAP_EMBED}
            className="w-full h-[500px] border-0"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
      </section>
      <ContactInfo />
    </main>
  );
};

export default Contact;
